import {useTransactionStore} from "../../stores/useTransactionStore";

//export const useTransactionData = () =>useTransactionStore((state) => state.data);

export const useTransactionObject = () =>
    useTransactionStore((state) => state.object);

export const useTransactionRefundObject = () =>
    useTransactionStore((state) => state.refundObject);

export const useTransactionResponseObject = () =>
    useTransactionStore((state) => state.responseObject);

export const useTransactionItemObject = () =>
    useTransactionStore((state) => state.transactionItemObject);
export const useTransactionList = () =>
    useTransactionStore((state) => state.list);

export const useTransactionLoading = () =>
    useTransactionStore((state) => state.loading);
export const useTransactionLValidationErrors = () =>
    useTransactionStore((state) => state.validationErrors);
export const useTransactionUploadFiles = () =>
    useTransactionStore((state) => state.uploadedFiles);
export const useTransactionLToastModel = () =>
    useTransactionStore((state) => state.toastModel);

export const useTransactionShowDeleteModal = () =>
    useTransactionStore((state) => state.showDeleteModal);
export const useShowPaymentDetailsModel = () =>
    useTransactionStore((state) => state.showPaymentDetailsModel);

export const useShowRefundItemModel = () =>
    useTransactionStore((state) => state.showRefundItemModel);

export const useShowDeleteModal = () =>
    useTransactionStore((state) => state.showDeleteModal);
export const useTransactionPrintObject = () =>
    useTransactionStore((state) => state.printObject);

export const useTransactionSearchRequest = () =>
    useTransactionStore((state) => state.searchRequest);

export const useTransactionTotalRows = () =>
    useTransactionStore((state) => state.totalRows);

export const useTransactionResetKey = () =>
    useTransactionStore((state) => state.resetKey);

export const useTransactionRefreshListTrigger = () =>
    useTransactionStore((state) => state.refreshListTrigger);

export const useTransactionActivePageKey = () =>
    useTransactionStore((state) => state.transactionActivePageKey);

export const useComponentActionType = () =>
    useTransactionStore((state) => state.componentActionType);

export const useTransactionType = () =>
    useTransactionStore((state) => state.transactionType);

export const useGuidKey = () =>
    useTransactionStore((state) => state.guidKey);

